import { jsx as _jsx } from "react/jsx-runtime";
// Importing skeletons
import { PlayerSkeletonAudio } from './skeleton-audio';
import { PlayerSkeletonVideo } from './skeleton-video';
// Importing types
import { PlayerType } from '../../../types/player';
// ----------------------------------------------------------------------
export const PlayerSkeleton = (props) => {
    // Destructuring props
    const { type = PlayerType.audio } = props;
    // Returning the correct skeleton based on the type
    return type === PlayerType.audio ? _jsx(PlayerSkeletonAudio, {}) : _jsx(PlayerSkeletonVideo, {});
};
